<template>
    <div>
        <UserAppNavbar></UserAppNavbar>
        <div class="p-4 md:p-6 lg:p-8 py-8">
            <template v-if="$store.state.users?.need_verification">
                <Message :closable="resend" severity="warn" v-if="!resend" @click="onResendTokenActivate">
                    Your account is not active, check your email for activation. <a href="javascript:void(0)"><span class="message-span" :class="{ 'disabled-link': resend }">Resend</span></a>
                </Message>
                <Message :closable="false" severity="success" v-if="resend"> Your activation link has been sent, please check your inbox or spam </Message>
                <Message :closable="true" severity="error" v-if="error.is_error" @close="onCloseError"> {{ error.message }} </Message>
            </template>
            <router-view></router-view>
        </div>
        <UserAppFooter />
        <TawkWidget />
    </div>
</template>

<script>
import UserAppNavbar from '@/layout/user/AppNavbar.vue';
import UserAppFooter from '@/layout/user/AppFooter.vue';
import TawkWidget from '@/components/_global/TawkWidget.vue';

export default {
    name: 'UserAppLayout',
    data: () => ({
        error: {
            is_error: false,
            message: null
        },
        resend: false
    }),
    methods: {
        async onResendTokenActivate() {
            this.$JsLoadingOverlay.show();
            try {
                await window.axios.post('/v1/auth/resend-token');
                this.resend = true;
            } catch ({ response: { data } }) {
                if (Object.keys(data).includes('error')) {
                    var {
                        error: { message }
                    } = data;
                } else {
                    var { message } = data;
                }

                this.error.is_error = true;
                this.error.message = message;
                console.error(message);
            } finally {
                this.$JsLoadingOverlay.hide();
            }
        },
        onCloseError() {
            this.error.is_error = false;
            this.error.message = null;
        }
    },
    components: {
        UserAppNavbar,
        UserAppFooter,
        TawkWidget,
    }
};
</script>

<style scoped>
.message-span {
    color: #2563eb;
}

.disabled-link {
    color: rgb(191, 201, 217);
}

a:has(> .disabled-link) {
    cursor: text;
    pointer-events: none;
}
</style>
